<template>
<div class="chapter">
<div class="inner_page">
<h1 class="partnum"><a id="page_3"></a><a id="p01"></a>Part One</h1>
<h1 class="parttitle">Exceptional Leaders Own the Accelerator</h1>
<div class="sidebar">
<p class="sidebartitle"><b><i>Immutable Law of Speed #1</i></b></p>
<p class="text1"><b><i>You own the accelerator for the speed of your own work and the work of those you lead.</i></b></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_part01.vue?3b1f639b